<footer class="footer">
  <div class="container">
    <div class="footer__grid">
      <div class="footer__brand">
        <img
          [ngSrc]="logoSrc()"
          [alt]="restaurantName() + ' logó – Pákozd, Velencei-tó'"
          class="footer__logo-img"
          width="80"
          height="80"
          loading="lazy"
        />
        <span class="footer__logo brand-name">{{ restaurantName() }}</span>
        <p class="footer__tagline">
          {{ tagline() }}
        </p>
      </div>

      <div class="footer__nav">
        <h4>Navigáció</h4>
        <ul>
          @for (link of navLinks(); track link.anchor) {
            <li><a (click)="scrollTo(link.anchor)">{{ link.label }}</a></li>
          }
        </ul>
      </div>

      <div class="footer__social">
        <h4>Kövess minket</h4>
        <div class="footer__social-links">
          @for (social of socials; track social.name) {
            <a [href]="social.url" [attr.aria-label]="social.name" class="social-link">
              {{ social.name }}
            </a>
          }
          <a routerLink="/impresszum" class="social-link">Impresszum</a>
          <a routerLink="/adatkezelesi-tajekoztato" class="social-link">Adatkezelési tájékoztató</a>
        </div>
        <a
          href="https://pacalkereso.hu"
          target="_blank"
          rel="noopener noreferrer"
          class="footer__pacal-banner-link"
        >
          <img
            src="assets/pacalkereso-banner.png"
            alt="pacalkereso.hu – Rajta vagyunk a pacaltérképen!"
            class="footer__pacal-banner"
            width="1024"
            height="253"
            loading="lazy"
          />
        </a>
      </div>
    </div>

    <div class="footer__bottom">
      <p>&copy; {{ currentYear }} <span class="brand-name">{{ restaurantName() }}</span>. Minden jog fenntartva.</p>
      <p class="footer__credit">
        A weboldalt a
        <a href="https://pacalkereso.hu" target="_blank" rel="noopener noreferrer">pacalkereso.hu</a>
        készítette.
      </p>
    </div>
  </div>
</footer>
